import React from 'react'
import './Card.css'
import { Link, useLocation } from 'react-router-dom';
const Card = ({ image, title, description, id,redirectionUrl }) => {
  const location=useLocation();
  console.log('location',location);
  console.log('location.pathname',location.pathname);
  
  return (
    <div className="custom-block-wrap">
      {/* Card Image */}
      <img src={image} className="custom-block-image img-fluid" alt={title} />

      <div className="custom-block">
        <div className="custom-block-body">
          {/* Card Title */}
          <h5 className="mb-3">{title}</h5>

          {/* Card Description */}
          <p>{description}</p>
        </div>

        {/* Donate Button */}
        {/* {redirectionUrl && (
          <a href={redirectionUrl} className="custom-btnUrl ">
            Learn More &gt;
          </a>
        )} */}
         {id && location.pathname=='/business/ecopalm-products' && (
          <Link to={`/business/ecopalm-products/${id}`}  className="custom-btnUrl">View Details</Link>
        )}
         {id && location.pathname=='/business/agricultural-commodities' && (
          <Link to={redirectionUrl}  className="custom-btnUrl">View Details</Link>
        )}
         {id && location.pathname=='/business/agricultural-commodities/nuts' && (
          <Link to={redirectionUrl}  className="custom-btnUrl">View Details</Link>
        )}
         
      </div>
    </div>
  );
};

export default Card;

